((window, $) => {
    const getQueryParams = (url) => {
	let queryParams = {};
	//create an anchor tag to use the property called search
	let anchor = document.createElement('a');
	//assigning url to href of anchor tag
	anchor.href = url;
	//search property returns the query string of url
	let queryStrings = anchor.search.substring(1);
	let params = queryStrings.split('&');

	for (var i = 0; i < params.length; i++) {
            var pair = params[i].split('=');
            queryParams[pair[0]] = decodeURIComponent(pair[1]);
	}
	return queryParams;
    };

    const def = window.def = {}
    const mods = {}
    const baseContext = {
	$: jQuery,
	win: window,
	$win: $(window),
	$body: $('body'),
	params: getQueryParams()
    }

    def.decodeHTML = input => {
	var e = document.createElement('div');
	e.innerHTML = input;
	return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }

    def.globals = {}

    def.mod = (name, callback) => {
	if(mods[name]) return console.error(`mod defined more than once: ${name}`)
	mods[name] = callback
    }

    def.getModContext = ($el) => {
	const context = $.extend({}, baseContext, {
	    $el: $el,
	    data: $el.data()
	})
	return context
	
    }

    def.modularize = ($els, module) => {
	const callback = mods[module]
	if(!callback) {
	    return console.warn(`data-module attribute doesn't match an existing module: ${module}`)
	}

	$els.each(function() {
	    const $el = $(this)
	    const context = def.getModContext($el)
	    callback(context)
	})
	
    }

    def.modularizeByAttr = ($els, attr) => {
	$els.each(function() {
	    const $el = $(this)
	    const module = $el.attr(attr)
	    // if(!module) return console.warn(`attempting to modularize element by an attribute it does not define: ${attr}`)
	    if(module) def.modularize($el, module)
	})
    }

    let filters = {}

    def.listen = (filter, callback) => {
	if (!filters[filter]) {
	    filters[filter] = [];
	}
	filters[filter].push({
	    callback: callback,
	});
    };

    def.fire = (filter, context) => {
	var listeners = filters[filter];

	if (!listeners || !listeners.length) return;
	listeners.forEach((listener) => {
	    if (listener.callback) {
		listener.callback(context);
	    }
	});
    };
    
    $(() => {
	def.modularizeByAttr($('[data-module]'), 'data-module')
    })
})(window, jQuery)
